import React from 'react'
import HeroHeader from './HeroHeader'
import HeroBody from './HeroBody'

function Hero() {
  return (
    <>
       <HeroHeader />
       <HeroBody />
    </>
  )
}

export default Hero